angular.module('unergie.main')
.directive('warningsadditional', () =>
    ({
        restrict: 'E',
        templateUrl: '/directives/warningsadditional/warningsadditional.html',
        scope: {
            warning: '=',
        },
    }),
)
